/**
 * Rendering a value that may not be there. CLAUDE.md §16.3.
 *
 * "null ≠ 0 ≠ 'not done' ≠ 'declined' ≠ 'unknown'. A missing glucose is not a
 * normal glucose."
 *
 * One component so the three cases look different everywhere, rather than each
 * screen choosing its own dash. The distinction is carried in the markup as
 * well as the text: a screen reader should not have to infer from a hyphen that
 * nothing was measured.
 */

import type { JSX } from 'react';

import type { DisplayValue } from '@glycemia/web-kit';

export const Value = ({ value }: { readonly value: DisplayValue }): JSX.Element => {
  if (value.kind === 'value') return <span className="value">{value.text}</span>;

  if (value.kind === 'absent') {
    return (
      <span className="value value--absent" title={value.reason}>
        Not recorded<span className="value__reason"> — {value.reason}</span>
      </span>
    );
  }

  return (
    <span className="value value--missing">
      <span aria-hidden="true">—</span>
      <span className="visually-hidden">No value recorded</span>
    </span>
  );
};
